'use strict';

const React = require('react');
const Picture = require('../elements/Picture');
const PublicationTime = require('../elements/PublicationTime.jsx');
const Link = require('../elements/SVTLink');

module.exports = React.createClass({

	displayName: 'Article',

	propTypes: {
		program: React.PropTypes.shape({
			title: React.PropTypes.string.isRequired
		}).isRequired,
		article: React.PropTypes.shape({
			title: React.PropTypes.string.isRequired,
			cover: React.PropTypes.object
		}).isRequired
	},
	/*
	_getLatestArticle: function () {
		var latestArticle = null;
		var program = this.props.program;

		if (program && program.articles && program.articles.length > 0) {
			latestArticle = program.articles[0];
		}


		return latestArticle;
	},
	*/
	render: function () {

		var program = this.props.program;
		var article = this.props.article;

		if (!(program && article) && !(program.id && article.id)) {
			return false;
		}

		var url = '/' + program.id + '/' + article.id;

		return (
			<article className="svtse_article">

				<Link className="svtse_article__link" to={url}>
					<Picture className="svtse_article__fig" model={article.cover} type="small" />
					<div className="svtse_article__text">
						<h3 className="svtse_article__title-headline">{article.title}</h3>
						<p className="svtse_article__body-copy">{article.leadText}</p>
						<p className="svtse_article__body-copy--published-date"><PublicationTime dateTime={article.publishedDate}/></p>
					</div>

				</Link>
			</article>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/Program/Article.js
 **/